// helper functions to check if a topic is void
const topicFilter = {
  isNone: (t = {}) => t.id === 1199,
  isNotNone: (t = {}) => t.id !== 1199,
};

export default topicFilter;
